import React from 'react';
import Typography from '@mui/material/Typography';
import {
  HButton,
  HDialog,
  HDialogActions,
  HDialogContent,
  HDialogTitle,
  HSpinner,
} from 'BaseComponents';


const ConfirmationDialog = (
  {
    open,
    title,
    message,
    loading,
    error,
    onCancel,
    cancelActionLabel = 'Cancel',
    onConfirm,
    confirmActionLabel = 'Confirm',
    slots,
    slotProps,
  },
) => (
  <HDialog
    open={open}
    onClose={onCancel}
    fullWidth
    maxWidth='xs'
    aria-labelledby='confirmation-dialog'
    aria-describedby='confirmation-dialog'
  >
    <HDialogTitle onClose={onCancel}>
      {title}
    </HDialogTitle>
    {slots?.content || (
      <HDialogContent {...(slotProps?.content ?? {})}>
        <Typography
          variant='body2'
          data-testid='confirm-message'
          sx={{ whiteSpace: 'pre-line' }}
        >
          {message}
        </Typography>
        {error && (
          <Typography color='error'>
            {error}
          </Typography>
        )}
      </HDialogContent>
    )}
    {slots?.actions || (
      <HDialogActions {...(slotProps?.actions ?? {})}>
        {onCancel && (
          <HButton variant='outlined' onClick={onCancel} size='small' data-testid='cancel-button'>
            {cancelActionLabel}
          </HButton>
        )}
        <HButton
          variant='contained'
          color='primary'
          size='small'
          onClick={onConfirm}
          endIcon={loading ? <HSpinner isButton /> : null}
          disabled={loading}
          data-testid='confirm-button'
        >
          {confirmActionLabel}
        </HButton>
      </HDialogActions>
    )}
  </HDialog>
);

export default ConfirmationDialog;
